import { render, staticRenderFns } from "./ServiceTypeLineAdd.vue?vue&type=template&id=589e90ba&"
import script from "./ServiceTypeLineAdd.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeLineAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports